<!--
 * @Description: 运维巡检计划列表
-->
<template>
  <scroll-layout class="inspection-plan-list">
    <template slot="header">
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @clean="handleSearchClean"
        @click="handleSearchConfirm"></ykc-search>
    </template>
    <ykc-table
      ref="YkcTable"
      operateFixedType="right"
      :data="tableData"
      title="运维巡检计划"
      :columns="tableColumns"
      :operateButtons="tableOperateButtons.filter(item => item.enabled())">
      <template #headerButtons>
        <div class="table-header-button">
          <ykc-button v-rbac="'operation:inspectionPlan:add'" type="plain" @click="handleAdd">
            新建巡检计划
          </ykc-button>
        </div>
      </template>
      <ykc-pagination
        align="right"
        slot="pagination"
        ref="YkcPagination"
        :total="pageInfo.total"
        :page-size.sync="pageInfo.size"
        :current-page.sync="pageInfo.current"
        @size-change="handlePaginationSizeChange"
        @current-change="handlePaginationCurrentChange"></ykc-pagination>
    </ykc-table>

    <!-- 新增/编辑侧边弹窗 -->
    <add-or-edit
      v-if="addOrEditVisible"
      :visible.sync="addOrEditVisible"
      :editId="editId"
      @save-success="handleSaveSuccess"></add-or-edit>

    <!-- 详情弹窗 -->
    <detail-dialog
      v-if="detailVisible"
      :visible.sync="detailVisible"
      :detailId="detailId"></detail-dialog>

    <!-- 删除二次确认弹窗 -->
    <el-dialog
      title="删除确认"
      :visible.sync="deleteConfirmVisible"
      width="420px"
      :append-to-body="true">
      <span>确认删除该巡检计划吗？删除后不可恢复。</span>
      <span slot="footer">
        <ykc-button type="plain" @click="deleteConfirmVisible = false">取消</ykc-button>
        <ykc-button type="primary" @click="confirmDelete">确定</ykc-button>
      </span>
    </el-dialog>
  </scroll-layout>
</template>

<script>
  import { inspectionPlanApi } from '@/service/apis';
  import AddOrEdit from './AddOrEdit.vue';
  import DetailDialog from './Detail.vue';

  export default {
    name: 'InspectionPlanList',
    components: { AddOrEdit, DetailDialog },
    data() {
      return {
        searchParams: {
          creatorName: '',
          dateRange: [],
          stationName: '',
          status: 0,
        },
        tableData: [],
        pageInfo: { total: 0, current: 1, size: 10 },
        addOrEditVisible: false,
        editId: null,
        detailVisible: false,
        detailId: null,
        deleteConfirmVisible: false,
        deleteId: null,
      };
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcInput',
            key: 'creatorName',
            label: '巡检人',
            placeholder: '请输入巡检人',
          },
          {
            comName: 'YkcDatePicker',
            key: 'dateRange',
            label: '巡检时间',
            startPlaceholder: '开始日期',
            endPlaceholder: '结束日期',
            type: 'daterange',
            valueFormat: 'yyyy-MM-dd',
          },
          {
            comName: 'YkcInput',
            key: 'stationName',
            label: '巡检电站',
            placeholder: '请输入电站名称',
          },
          {
            comName: 'YkcDropdown',
            key: 'status',
            label: '状态',
            placeholder: '请选择状态',
            data: [
              { id: 0, name: '全部' },
              { id: 1, name: '未到期' },
              { id: 2, name: '已到期' },
            ],
          },
        ];
      },
      tableColumns() {
        return [
          { label: '巡检计划编码', prop: 'planCode', minWidth: '160px' },
          { label: '巡检人', prop: 'creatorName', minWidth: '100px' },
          { label: '巡检时间', prop: 'inspectionDate', minWidth: '120px' },
          { label: '巡检城市', prop: 'cityName', minWidth: '100px' },
          { label: '巡检电站数', prop: 'stationCount', minWidth: '100px', align: 'center' },
          {
            label: '状态',
            prop: 'status',
            minWidth: '90px',
            align: 'center',
            scopedSlots: {
              default: ({ row }) => {
                return row.status === 1 ? (
                  <span style="color:#38a169">未过期</span>
                ) : (
                  <span style="color:#909399">已过期</span>
                );
              },
            },
          },
          {
            label: '巡检电站手动调整原因',
            prop: 'adjustReason',
            minWidth: '180px',
            formatter: row => row.adjustReason || '--',
          },
          { label: '最后编辑人', prop: 'lastEditorName', minWidth: '100px' },
          { label: '最后编辑时间', prop: 'lastEditTime', minWidth: '160px' },
        ];
      },
      tableOperateButtons() {
        return [
          {
            enabled: () => true,
            render: (h, data, { row }) => {
              return (
                <ykc-button type="text" onClick={() => this.handleDetail(row)}>
                  详情
                </ykc-button>
              );
            },
          },
          {
            enabled: () => true,
            render: (h, data, { row }) => {
              if (row.status !== 1) return '';
              return (
                <ykc-button type="text" onClick={() => this.handleEdit(row)}>
                  编辑
                </ykc-button>
              );
            },
          },
          {
            enabled: () => true,
            render: (h, data, { row }) => {
              if (row.status !== 1) return '';
              return (
                <ykc-button type="text" onClick={() => this.handleDelete(row)}>
                  删除
                </ykc-button>
              );
            },
          },
        ];
      },
    },
    mounted() {
      this.getList();
    },
    methods: {
      handleSearchConfirm(data) {
        this.searchParams = { ...this.searchParams, ...data };
        this.pageInfo.current = 1;
        this.getList();
      },
      handleSearchClean() {
        this.searchParams = {
          creatorName: '',
          dateRange: [],
          stationName: '',
          status: 0,
        };
        this.pageInfo.current = 1;
        this.getList();
      },
      handlePaginationSizeChange(size) {
        this.pageInfo.size = size;
        this.pageInfo.current = 1;
        this.getList();
      },
      handlePaginationCurrentChange(current) {
        this.pageInfo.current = current;
        this.getList();
      },
      getList() {
        const params = {
          creatorName: this.searchParams.creatorName,
          stationName: this.searchParams.stationName,
          status: this.searchParams.status,
          orderByLastEditTime: true,
          current: this.pageInfo.current,
          size: this.pageInfo.size,
        };
        if (this.searchParams.dateRange && this.searchParams.dateRange.length === 2) {
          params.inspectionDateStart = this.searchParams.dateRange[0];
          params.inspectionDateEnd = this.searchParams.dateRange[1];
        }
        inspectionPlanApi.getPage(params).then(res => {
          this.tableData = res.records || [];
          this.pageInfo.total = res.total || 0;
        });
      },
      handleAdd() {
        this.editId = null;
        this.addOrEditVisible = true;
      },
      handleEdit(row) {
        this.editId = row.id;
        this.addOrEditVisible = true;
      },
      handleDetail(row) {
        this.detailId = row.id;
        this.detailVisible = true;
      },
      handleDelete(row) {
        this.deleteId = row.id;
        this.deleteConfirmVisible = true;
      },
      confirmDelete() {
        inspectionPlanApi.delete(this.deleteId).then(() => {
          this.$message.success('删除成功');
          this.deleteConfirmVisible = false;
          this.getList();
        });
      },
      handleSaveSuccess() {
        this.addOrEditVisible = false;
        this.getList();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .inspection-plan-list {
    .table-header-button {
      display: flex;
      gap: 8px;
    }
  }
</style>
